import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import MyInvoicesPage from './MyInvoicesPage';
import { getMyInvoicesData, printInvoice, resetPaymentArray } from 'src/actions/paidInvoiceAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';

export const mapStateToProps = (state: AppState) => {
  return {
    myInvoicesData: state.paidInvoice.myInvoicesData,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    onComponentDidMount: () => {
      dispatch(resetPaymentArray('myinvoices'));
    },
    onComponentWillMount: () => {
      dispatch(doCheckAuthentication);
    },
    dateFilter: (filterStartdate: Date, filterEnddate: Date) => {
      dispatch(getMyInvoicesData(filterStartdate, filterEnddate));
    },
    dateReset: (filterStartdate: Date, filterEnddate: Date) => {
      dispatch(getMyInvoicesData(filterStartdate, filterEnddate));
    },
    printTxn: (txn: String, type: String) => {
      dispatch(printInvoice(txn, type));
    }
  };
};

const MyInvoicesContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(MyInvoicesPage);

export default MyInvoicesContainer;



// WEBPACK FOOTER //
// ./src/components/MyInvoices/MyInvoicesContainer.tsx